import * as api from '../contactApi';
import {
  call,
  put,
  select,
  takeEvery
  } from 'redux-saga/effects';
import { contactActionCreators } from '../contactActionCreators';
import { ContactActionKeys, FetchContactsById, IContact } from '..';
import { IState } from '../..';
import { uiActionCreators } from '../../ui';
import {} from '../contactInterfaces';

function* fetchContactsByIdSaga(action: FetchContactsById) {
  const idsToFetch: number[] = yield select((state: IState) =>
    action.payload.contactIds.filter(x => !state.contacts.hash[x])
  );

  if (idsToFetch.length > 0) {
    yield put(uiActionCreators.toggleLoading('contactsById'));

    const response: IContact[] = yield call(api.fetchContactsById, idsToFetch);

    yield put(contactActionCreators.processContacts(response));
    yield put(uiActionCreators.toggleLoading('contactsById'));
  }
}

export function* watchFetchContactsById() {
  yield takeEvery(ContactActionKeys.FETCH_CONTACTS_BY_ID, fetchContactsByIdSaga);
}
